import {
    Component,
    ContentChild,
    TemplateRef,
    Inject,
    forwardRef,
} from '@angular/core'

import { connectStats } from 'instantsearch.js/es/connectors'
import {
    StatsConnectorParams,
    StatsWidgetDescription,
    StatsRenderState,
} from 'instantsearch.js/es/connectors/stats/connectStats'

import { AbstractInstantsearchWidgetComponent } from '@app-domains/algolia/abstract-instantsearch-widget.component'
import { AlgoliaInstantsearchComponent } from '@app-domains/algolia/components/algolia-instantsearch.component'

@Component({
    selector: 'app-algolia-stats',
    template: `
    <div [class]="cx()">
      <ng-container *ngTemplateOutlet="template; context: templateContext">
      </ng-container>

      <span *ngIf="!template" [class]="cx('text')">
        {{state.nbHits}} results found in {{state.processingTimeMS}}ms.
      </span>
    </div>
  `,
})
export class AlgoliaStatsComponent extends AbstractInstantsearchWidgetComponent<
StatsWidgetDescription,
StatsConnectorParams
> {

    public widgetName: string

    @ContentChild(TemplateRef, { static: false })
    public template: any

    public override state: StatsRenderState = {
        nbHits: 0,
        nbPages: 0,
        page: 0,
        processingTimeMS: 0,
        query: '',
        areHitsSorted: false,
    }

    get templateContext() {
        return { state: this.state }
    }

    constructor(

        @Inject(forwardRef(() => AlgoliaInstantsearchComponent))
        public instantSearchInstance: AlgoliaInstantsearchComponent,
    ) {
        super()

        this.createWidget(
            connectStats,
            {},
            {
                $$widgetType: 'ais.stats',
            },
        )
    }
}
